import React, { useState } from "react";
import { useParams } from "react-router";
import { isErrorMessage } from "@sscs/types";
import { LoginLayout } from "Components";
import { useVerifyUserInviteQuery } from "../../services/invite.api";
import AcceptInviteContent from "./AcceptInviteContent";

const AcceptInvite = (): React.JSX.Element => {
  const { inviteToken = "" } = useParams();

  const [isAccountCreated, setAccountCreated] = useState(false);

  const {
    isLoading: isVerifyingInvite,
    isError: hasInviteVerificationFailed,
    error,
  } = useVerifyUserInviteQuery({
    inviteToken,
  });

  return (
    <LoginLayout>
      <AcceptInviteContent
        isVerifyingInvite={isVerifyingInvite}
        hasInviteVerificationFailed={hasInviteVerificationFailed}
        isAccountCreated={isAccountCreated}
        validationError={isErrorMessage(error) ? error.data.error : undefined}
        onAccept={() => setAccountCreated(true)}
      />
    </LoginLayout>
  );
};

export default AcceptInvite;
